import { observable, action,computed } from "mobx";
import { post } from "../services/ajax.service";

class EligibilityStore {
  @observable uneligible_participants = [];
  @observable timeline_claims = [];
  @observable duplicate_count = 0;
  @observable duplicate_cost = 0;
  @observable duplicates = [];
  @observable count = 0;
  @observable expanded_records = []
  @observable url = "/api/v1/insightactions/eligibility";

  @computed get tiles() {
    return parseInt(this.count % 100) > 0 ? parseInt(this.count / 100) + 1 : parseInt(this.count / 100);
  }



  @action getDuplicateCost = async data => {
    this.duplicate_cost = 0
    try {
      let response = await post(
        `${this.url}/getDuplicateCost`,
        data
      );

      this.duplicate_cost = response.data[0].duplicate_cost;
    } catch (err) {
      console.log(err);
    }
  };

  @action getDuplicateCount = async data => {
    this.duplicate_count = 0;
    this.count = 0;
    try {
      let response = await post(
        `${this.url}/getDuplicateCount`,
        data
      );

      this.duplicate_count = this.count = response.data[0].duplicate_count;
    } catch (err) {
      console.log(err);
    }
  };



  @action getParticipantsNotinFile = async data => {
    this.uneligible_participants = []
    this.timeline_claims = []
    try {
      let response = await post(
        `${this.url}/getParticipantsNotinFile`,
        data
      );

      this.uneligible_participants = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getDuplicates = async data => {
    this.duplicates = []
    try {
      let response = await post(
        `${this.url}/getDuplicates`,
        data
      );

      this.duplicates = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getExpandedRecords = async data => {
    this.expanded_records = [];
    try {
      let response = await post(
        `${this.url}/getExpandedRecords`,
        data
      );
      this.expanded_records = response.data;
    }
    catch (err) {
      console.log(err)
    }
  }



  @action getIndividualClaimsTimeLine = async data => {
    this.timeline_claims = []
    try {
      let response = await post(
        `${this.url}/getIndividualClaimsTimeLine`,
        data
      );

      this.timeline_claims = response.data;
    } catch (err) {
      console.log(err);
    }
  };


}

export default EligibilityStore;
